import axios from './axios'
import qs from 'qs';
let userBastUrl = '/api/amazonRemovalReport/';
/**
 *
 *
 */
export default {
  list(data) {
    return axios.get(userBastUrl + 'list', {
      params: data
    });
  },
}
